import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
import en from "vuetify/src/locale/en";
import pt from "vuetify/src/locale/pt";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        deleteConfirmation: colors.red,
        background: "#f8f8f8",
        primary: "#27936f",
      },
    },
  },
  lang: {
    locales: { en, pt },
    current: "en",
  },
});

export function setVuetifyLocale(locale: string): void {
  const languageCode = locale.substring(0, 2);
  vuetify.framework.lang.current = languageCode;
}

export default vuetify;
